import React, { memo, useContext } from 'react';

import { LazySuspense } from 'react-loosely-lazy';

import { PeopleMenuContext } from '../../context/PeopleMenuContext';
import useBrowsePeoplePermission from '../../hooks/useBrowsePeoplePermission';
import { type PeopleMenuContentProps } from '../../types';
import { VOID_FUNC } from '../../utils/constants';
import { MenuContent, MenuContentFallback } from '../MenuContent/lazy';

import PeopleMenuProviders from './PeopleMenuProviders';

const stopPropagation = (e: React.MouseEvent<HTMLElement>) => e.stopPropagation();

export const PeopleMenuContentInternal = memo(() => {
	const { isBrowseUsersEnabled } = useContext(PeopleMenuContext);

	const { loading: isLoadingPermission, hasPermission } =
		useBrowsePeoplePermission(isBrowseUsersEnabled);

	return (
		// eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions, @atlassian/a11y/interactive-element-not-keyboard-focusable
		<span onClick={stopPropagation}>
			<LazySuspense fallback={<MenuContentFallback />}>
				<MenuContent isLoadingPermission={isLoadingPermission} hasPermission={hasPermission} />
			</LazySuspense>
		</span>
	);
});

const PeopleMenuContent = (props: PeopleMenuContentProps) => {
	return (
		<PeopleMenuProviders isOpen onOpen={VOID_FUNC} onClose={VOID_FUNC} {...props}>
			<PeopleMenuContentInternal />
		</PeopleMenuProviders>
	);
};

export default PeopleMenuContent;
